"use strict";

import fetch from "../libs/@elements/fetch"

export function init () {
    let paymentPending = document.getElementsByClassName('js-payment-pending');

    if(paymentPending.length>0) {
        let failedRequests = 0;
        let requestCount = 0;

        let url = paymentPending[0].getAttribute('data-url');

        let checkPending = function (timeout) {
            if(requestCount > 20) {
                return
            }

            setTimeout(
                function () {
                    requestCount++;

                    let pendingRequest = fetch(url);
                    pendingRequest
                        .then((res) => {
                            return res.clone().json()
                        }).then((res) => {

                        if (res.url) {
                            window.location.href = res.url;
                        } else {
                            checkPending((requestCount + 1) * 1000);
                        }
                    }).catch((error) => {
                        failedRequests++;
                        if(failedRequests < 3) {
                            checkPending((requestCount + 1) * 1000);
                        }
                    });
                }, timeout);

        };
        checkPending(2000);
    }
}